<template>
    <div>

        <script type="application/javascript" v-bind:src="hsCoreSrc"></script>

        <!-- ========== HEADER ========== -->
        <header id="header" class="u-header u-header--abs-top-md u-header--bg-transparent u-header--show-hide-md"
                data-header-fix-moment="500"
                data-header-fix-effect="slide">
            <div class="u-header__section">
                <TopBar/>

                <div id="logoAndNav" class="container">
                    <!-- Nav -->
                    <nav class="js-mega-menu navbar navbar-expand-md u-header__navbar u-header__navbar--no-space">
                        <Logo/>

                        <!-- Navigation if user is authenticated -->
                        <div v-if="user.authToken" id="navBar" class="collapse navbar-collapse u-header__navbar-collapse">
                            <ul class="navbar-nav u-header__navbar-nav">
                                    <!-- Button -->
                                    <li class="nav-item u-header__nav-last-item">
                                        <router-link class="btn btn-sm btn-outline-primary transition-3d-hover" :to="{'name': 'home'}">Entrer</router-link>
                                    </li>
                                    <!-- End Button -->
                                </ul>
                        </div>
                        <!-- End Navigation -->

                        <!-- Navigation if user is not authenticated yet -->
                        <div v-else id="navBar" class="collapse navbar-collapse u-header__navbar-collapse">
                            <ul class="navbar-nav u-header__navbar-nav">
                            <!-- Button -->
                            <li class="nav-item u-header__nav-last-item">
                                <router-link class="btn btn-sm btn-primary transition-3d-hover"
                                             :to="{'name': 'login'}">Se connecter</router-link>
                            </li>
                            <!-- End Button -->

                            <!-- Button -->
                            <li class="nav-item u-header__nav-last-item">
                                <router-link class="btn btn-sm btn-outline-primary transition-3d-hover"
                                             :to="{'name': 'signup'}">S'inscrire</router-link>
                            </li>
                            <!-- End Button -->
                        </ul>
                        </div>
                        <!-- End Navigation -->
                    </nav>
                    <!-- End Nav -->
                </div>
            </div>
        </header>
        <!-- ========== END HEADER ========== -->

        <!-- ========== MAIN CONTENT ========== -->
        <main id="content" role="main">
            <!-- Hero Section -->
            <div class="container space-2 space-top-md-5 space-top-lg-4 space-bottom-lg-3">
                <div class="row justify-content-lg-between mb-7">
                    <div class="col-lg-5 mb-7 mb-lg-0">
                        <!-- Info -->
                        <div class="mb-5">
                            <h1 class="h2 font-weight-medium mb-3">Trouvez facilement satisfaction à tous vos besoins.</h1>
                            <p>ResolveNeed vous permet de poster vos besoins et de vous assurer que l'audience que vous ciblez en soit notifiée
                                dans les plus brefs délais.</p>
                        </div>

                        <div class="mb-3">
                            <router-link class="btn btn-primary btn-wide transition-3d-hover mb-2 mb-sm-0 mr-3"
                                         :to="{'name': 'signup'}">Commencer</router-link>
                            <a class="btn btn-outline-primary btn-wide transition-3d-hover mb-2 mb-sm-0"
                               href="#footer">Contactez nous</a>
                        </div>

                        <p class="small">Commencez aujourd'hui. C'est absolument gratuit.</p>
                        <!-- End Info -->
                    </div>

                    <div class="col-lg-6">
                        <!-- SVG Illustration -->
                        <figure id="SVGHero" class="w-md-75 w-lg-100">
                            <img src="../../public/assets/svg/illustrations/undraw/celebration.svg" width="540px" height="405px" alt="Image Description"
                                 data-parent="#SVGHero">
                        </figure>
                        <!-- End SVG Illustration -->
                    </div>
                </div>
            </div>
            <!-- End Hero Section -->
            <!-- Features Section -->
            <div class="container space-2 space-lg-3">
                <div class="row align-items-lg-center">
                    <div class="col-lg-5 order-lg-1">
                        <div class="mb-5">
                            <h2 class="font-weight-medium">Ne dépensez plus toute votre énergie sur les réseaux sociaux.</h2>
                            <p>Avec ResolveNeed, vous n'avez plus besoin de publier vos besoins dans tous vos groupes Whatsapp,
                                Facebook, etc, en espérant que quelqu'un vous fasse un retour un jour.</p>
                        </div>

                        <!-- Info -->
                        <ul class="list-unstyled">
                            <li class="media align-items-center pb-3">
                                  <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                                    <span class="fas fa-check btn-icon__inner"></span>
                                  </span>
                                <div class="media-body">
                                    <p class="text-dark mb-0">Vous faites un unique post sur notre plateforme.</p>
                                </div>
                            </li>
                            <li class="media align-items-center py-3">
                  <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                    <span class="fas fa-check btn-icon__inner"></span>
                  </span>
                                <div class="media-body">
                                    <p class="text-dark mb-0">Nous identifions tous ceux qui devraient pouvoir satisfaire votre besoin.</p>
                                </div>
                            </li>
                            <li class="media align-items-center pt-3">
                  <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                    <span class="fas fa-check btn-icon__inner"></span>
                  </span>
                                <div class="media-body">
                                    <p class="text-dark mb-0">Ils sont immédiatement notifiés et peuvent donc entrer en
                                        contact avec vous afin de vous proposer leurs services.</p>
                                </div>
                            </li>
                        </ul>
                        <!-- End Info -->
                    </div>
                    <div class="col-lg-7 order-lg-0">
                        <img src="../../public/assets/img/new/picture_0.png"/>
                    </div>
                </div>
            </div>
            <!-- End Features Section -->

            <!-- Features Section -->
            <div class="container space-2 space-lg-3">
                <div class="row align-items-lg-center">
                    <div class="col-lg-5 mb-7 mb-lg-0">
                        <div class="mb-5">
                            <h2 class="font-weight-medium">Trouvez/proposez des emplois plus facilement.</h2>
                            <p>Vous pouvez aussi utiliser notre plateforme pour publier vos offres d'emploi. Grâce à nos algorithmes,
                                vos publications iront directement dans les fils d'actualités de l'audience cible. Vous aurez alors très
                                vite des retours.</p>
                        </div>
                    </div>

                    <div class="col-lg-7">
                        <img src="../../public/assets/img/new/picture_1.png" class="border"/>
                    </div>
                </div>
            </div>
            <!-- End Features Section -->

            <!-- Features Section -->
            <div class="container space-2 space-lg-3">
                <div class="row align-items-lg-center">
                    <div class="col-lg-5 order-lg-2 mb-7 mb-lg-0">
                        <div class="mb-5">
                            <h2 class="font-weight-medium">Partagez des informations/annonces avec une audience bien ciblée.</h2>
                            <p>ResolveNeed vous permet également de partager des informations ou de publier des annonces, toujours
                                avec la garantie que vos publications atteindront les bonnes personnes.</p>
                        </div>
                    </div>

                    <div class="col-lg-7 order-lg-1">
                        <img src="../../public/assets/img/new/picture_2.png"/>
                    </div>
                </div>
            </div>
            <!-- End Features Section -->
        </main>
        <!-- ========== END MAIN CONTENT ========== -->

        <FooterA/>

        <GoToTop/>

    </div>
</template>

<script>
    import Logo from "../components/Logo";
    import GoToTop from "../components/GoToTop";
    import FooterA from "../components/FooterA";
    import TopBar from "../components/TopBar";
    import {mapState} from "vuex";
    import {JS_FILES} from "../settings/scripts";

    export default {
        name: "Welcome",
        data() {
            return {
                hsCoreSrc: JS_FILES.hs.core,
            }
        },
        computed: {
            ...mapState([
                'user'
            ]),
        },
        components: {TopBar, FooterA, GoToTop, Logo}
    }
</script>

<style scoped>
</style>